const post = true
const put = true
const remove = true
const create = true
const service = true
const get = true
const method_delet = true
const patch = true

const access = {
  get_access: { link: 'user/get_access' }
}

const reports = {
  summary: { link: 'reports/summary', post },
  summary_chart: { link: 'reports/summary', post },
  abc: { link: 'report/abc', post },
  by_shift: { link: 'reports/by_shift', post },
  shift_by_id: { link: 'shifts/get' },
  by_tax: { link: 'reports/by_tax', post },
  sales_by_category: { link: 'reports/sales/by_category/next', post },
  sales_by_item_above: { link: 'reports/sales/by_item/above', post },
  sales_by_item_below: { link: 'report/sales/by_item/below', post },
  sales_by_employee: { link: 'reports/sales/by_employee', post },
  sales_by_payment: { link: 'reports/sales/by_payment', post },
  by_receipt: { link: 'reports/by_receipt', post },
  receipt_by_id: { link: 'receipts/get' },
  by_discount: { link: 'reports/by_discount', post },
  by_debt: { link: 'reports/by_debt', post },
  by_modifier: { link: 'reports/by_modifier', post },
  report_consumption: { link: 'report/consumption', post },
  sales_by_supplier: { link: 'reports/sales/by_supplier', post },
  sales_by_supplier_view: { link: 'report/sales/by_supplier/by_item/below/61ced0719d2105d304172e20', post },
  workgroup_order_report: { link: 'workgroup/orders/report', post },
  workgroup_order_each_report: { link: 'workgroup/orders-each/report', post },
  safe_resport: { link: '/reports/safe', post },
  workgroup_report_employee: { link: 'workgroup/report/employee', post },
  sale_report_excel: { link: '/reports/sales/by_partitation-client', post, version: '1.0.0' }
}

const items = {
  list_of_items: { link: 'items/list_of_items' },
  suggestion_items_name: { link: 'items/suggestion/name', version: '2.0.0' },
  suggestion_items_mxik: { link: 'items/suggestion/mxik', version: '2.0.0' },
  list_of_inv_items: { link: 'items/list_of_inv_items' },
  list_of_item_variants: { link: 'items/list_of_variants' },
  get_available_sku: { link: 'items/get_available_sku' },
  suppliers: { link: 'inventory/get_suppliers', post },
  get_taxes: { link: 'settings/tax/get' },
  create_item: { link: 'items/create_item', post },
  create_item_variant: { link: 'items/create/with-variant', post },
  update_item_variant: { link: 'items/update/with-variant', post },
  get_item_by_id: { link: 'goods/sales/get' },
  list_of_categories: { link: 'items/list_of_categories' },
  moderator_list_of_categories: { link: '/moderator/items/draggable/list_of_categories', version: '2.0.0' },
  moderator_list_of_categories_update: { link: '/moderator/items/draggable/list_of_categories/update', version: '2.0.0', put },
  list_of_all_categories: { link: 'item/categories/all/get' },
  list_of_top_categories: { link: 'items/list_of_top_categories' },
  create_category: { link: 'goods/category/create-update/create', post },
  update_category: { link: 'goods/category/create-update', post },
  delete_category: { link: 'goods/category/delete_group', post },
  update_item: { link: 'items/update_item', post },
  update_item_fields: { link: 'items/update_item_fields' },
  sub_categories: { link: 'items/get/sub_categories' },
  get_category_by_id: { link: 'goods/category/get-by-id' },
  modifiers: { link: 'items/modifiers/searching', post },
  create_modifier: { link: 'items/modifiers/create', post },
  update_modifier: { link: 'items/modifiers/update', post },
  delete_modifiers: { link: 'modifiers/delete_group', post },
  modifier_get_by_id: { link: 'items/modifier/get' },
  discounts: { link: 'items/list_of_discounts', post },
  save_discount: { link: 'items/list_of_discounts/create', post },
  update_discount: { link: 'items/list_of_discounts/update', post },
  delete_discounts: { link: 'goods/discount/delete_group', post },
  discount_get_by_id: { link: 'items/list_of_discounts/get' },
  remove_items: { link: 'goods/sales/delete_group', post },
  create_item_variant_data: { link: 'items/variant/create', post },
  update_item_variant_data: { link: 'items/variant/update', post },
  update_items_prices: { link: 'items/pricing', post },
  items_price_change_history: { link: 'items/price_change_history', post },
  print_labels_auto_fill_by_date: { link: 'items/pricing/autofilll', post },
  get_weight_available_sku: { link: 'items/get_weight_sku', post },
  product_create: { link: 'product/create', post },
  product_search: { link: 'products/search', post },
  create_items_from_product: { link: 'items/create/from-products', post },
  tech_map_create: { link: '/tech_map/create', post },
  tech_map_update: { link: '/tech_map/update', post },
  tech_map_delete: { link: '/tech_map/delete_group', post },
  tech_map_get: { link: '/tech_map/get', post },
  tech_map_get_by_id: { link: '/tech_map/get-id', post },
  tech_map_get_by_item_id: { link: '/tech_map/get-item-id', post },
  set_service_prices: { link: 'items/prices/set/by-store', post },
  set_service_price: { link: 'items/price/set/by-store', post },
  pricing_process_check: { link: 'items/prices/set/by-store/check' },
  sync_with_mxik_finder_get_process: { link: '/items/sync-with/mxik-finder/get-last', post },
  sync_with_mxik_finder_start: { link: '/items/sync-with/mxik-finder', post },
  set_printed_time: { link: '/printed-items/set', post },
  printed_item_count: { link: '/printed-items/count', post },
  printed_item_get: { link: '/printed-items/get', post },
  mxik_get: { link: '/goods/search/mxik', post },
  promotion_get: { link: '/items/list_of_discounts', post },
  promotion_get_id: { link: '/items/list_of_discounts/get' },
  promotion_create: { link: '/items/list_of_discounts/create', post },
  promotion_update: { link: '/items/list_of_discounts/update', post },
}

const signing = {
  signup: { link: 'user/register', version: '2.0.0', post },
  signin: { link: 'user/login', post },
  verify: { link: 'user/login/verify', post },
}

const settings = {
  update_user: { link: 'user/update', post },
  features: { link: 'settings/general/features/get' },
  update_features: { link: 'settings/general/features/update', post },
  payment_types: { link: 'payment/types/get' },
  update_payment_types: { link: 'payment/types/update', post },
  loyalty: { link: 'organization' },
  update_loyalty: { link: 'organizations/update', post },
  taxes: { link: 'settings/tax/get', post, service },
  create_tax: { link: 'settings/tax/create' },
  update_tax: { link: 'settings/tax/update', post },
  delete_taxes: { link: 'settings/tax/delete_group', post },
  get_taxes_by_id: { link: 'settings/tax/get_by_id' },
  printers: { link: 'goods/section/searching', post },
  create_printer: { link: 'goods/section/create', post },
  update_printer: { link: 'goods/section/update', post },
  remove_printers: { link: 'goods/section/delete_group', post },
  tickets: { link: 'tables/search', post },
  update_tickets: { link: 'table/update_group', post },
  services: { link: 'services/get' },
  service_update: { link: 'services/update' },
  delete_service: { link: 'services/delete', remove },
  create_service: { link: 'organizations/service', post, create },
  // Customers
  customers: { link: 'clients/searching', post },
  create_customer: { link: 'customer/create', post },
  update_customer: { link: 'customer/update', post },
  customer_get_by_id: { link: 'customer/get' },
  delete_customers: { link: 'customer/delete_group', post },
  customer_pay_for_debt: { link: 'customer/pay-for/category', post },
  customer_debt_history: { link: 'customer-debt-history', post },
  sold_item_update: { link: '/customer/update-sold-item', post },
  sold_item_group_update: { link: '/customer/group-update-sold-item', post },
  devices: { link: 'posdevices/search', post },
  create_device: { link: 'posdevices/create', post },
  update_device: { link: 'posdevices/update', post },
  remove_devices: { link: 'posdevices/delete_group', post },
  get_buttons: { link: '/pays/buttons/search', post },
  create_button: { link: '/pays/buttons/create', post },
  update_button: { link: '/pays/buttons/update', post },
  delete_buttons: { link: '/pays/buttons/delete_group', post },
  get_currency: { link: '/currency/get' },
  update_currency: { link: '/currency/update', post },
  save_settings_receipt: { link: 'settings/receipts/update', post },
  get_settings_receipt: { link: 'settings/receipts/get', post },
  update_nds: { link: 'settings/nds/update', post },
  get_nds: { link: 'settings/nds/get' },
  options_get: { link: '/settings/options/get', post },
  options_create: { link: '/settings/options/create', post },
  options_update: { link: '/settings/options/update', post },
  options_delete_group: { link: '/settings/options/delete-group', post },
  organizations_get: { link: '/organization', get },
  organizations_update: { link: '/organization', patch },
  client_status_create: { link: '/tariffes/create', version: '2.0.0', post },
  client_status_get: { link: '/tariffes/get', version: '2.0.0' },
  remove_status: { link: '/tariffes/delete_group', version: '2.0.0', method_delet },
  client_status_update: { link: '/tariffes/update', version: '2.0.0', post }
}

const employees = {
  employees: { link: 'user/searching', post },
  get_employee_by_id: { link: 'getEmployeeByID' },
  all_employees: { link: 'get_employeess', post },
  create_employee: { link: 'user/create', post },
  roles: { link: 'access/get/roles' },
  update_employee: { link: 'user/update', post },
  delete_employees: { link: 'user/delete_group', post },
  access: { link: 'access/get' },
  accesses: { link: 'access/searching' },
  create_access: { link: 'access/create', post },
  update_access: { link: 'access/update', post },
  delete_access: { link: 'access/delete_group', post },
  worked_hours: { link: 'worked/hours', post },
  employee_timecards: { link: 'employees/timecard', post },
  create_timecard: { link: 'employees/timecard/create', post },
  update_timecard: { link: 'employees/timecard/update', post },
  delete_timecards: { link: 'employees/timecard/delete_group', post },
  get_workgroup: { link: 'workgroup/get' },
  update_workgroup: { link: 'workgroup/update_group', post },
  update_workgroup_by_id: { link: 'workgroup/update', post },
  create_task: { link: 'kpi/task/add', post },
  update_task: { link: 'kpi/task', post },
  get_task_list: { link: 'kpi/task' },
  get_a_task: { link: 'kpi/task' },
  delete_a_task: { link: 'kpi/task', post },
  get_workgroup_order_list: { link: 'workgroup/order/list', post },
  create_workgroup_order: { link: 'workgroup/order/create', post },
  get_workgroup_get_by_id: { link: 'workgroup/order/admin-get' },
  cancel_workgroup_order: { link: '/workgroup/order/cancel' },
  undo_workgroup_order: { link: 'workgroup/order/undo' },
  workgroup_order_confirm: { link: 'workgroup/order/confirm/complete', post },
  workgroup_order_order_information_create: { link: 'workgroup/order-information/create', post },
  workgroup_order_order_information_get: { link: 'workgroup/order-information/get', post },
  workgroup_order_order_information_get_own: { link: 'workgroup/order-information/get-own', post },
  workgroup_order_order_information_details: { link: 'workgroup_order/order-information/get/details', post },
  workgroup_order_device_information_create: { link: 'workgroup/device-information/create', post },
  workgroup_order_device_information_get: { link: 'workgroup/device-information/get', post },
  workgroup_order_device_information_get_own: { link: 'workgroup/device-information/get-own', post },
  workgroup_order_device_information_details: { link: 'workgroup_order/device-information/get/details', post },
  workgroup_order_additional_information_create: { link: 'workgroup/additional-information/create', post },
  workgroup_order_additional_information_get: { link: 'workgroup/additional-information/get', post },
  workgroup_order_additional_information_get_own: { link: 'workgroup/additional-information/get-own', post },
  workgroup_order_additional_information_details: { link: 'workgroup_order/additional-information/get/details', post },
  workgroup_comments_get: { link: 'workgroup/comments/get' },
  workgroup_comments_get_own: { link: 'workgroup/comments/get-own' },
  workgroup_comments_create: { link: 'workgroup/comments/create', post },
  workgroup_order_items_update: { link: 'workgroup/order/update/items', post },
  workgroup_order_shifts_get: { link: 'workgroup/order/shifts-get', post },
  workgroup_order_get_for_edit: { link: 'workgroup/order/admin-get-for-edit' },
  workgroup_order_update: { link: 'workgroup/order/update' },
}

const inventory = {
  link_umar: `invan-download/inventory/history/excel-file`,
  create_supplier: { link: 'inventory/create_supplier', post },
  supplier: { link: 'inventory/get_supplier' },
  update_supplier: { link: 'inventory/update_supplier', post },
  delete_suppliers: { link: 'inventory/delete_suppliers', post },
  all_suppliers: { link: 'inventory/get_suppliers' },
  purchase: { link: 'inventory/get_purchase_order' },
  purchase_by_id: { link: 'inventory/get_purchase_order' },
  purchases: { link: 'inventory/get_purchase_order', post },
  purchase_employees: { link: 'employee/orders/get', post, version: '2.0.0' },
  partition_item_supplier: { link: 'inventory/partiation/item/suppliers', post, version: '2.0.0' },
  get_items_for_purchase: { link: 'inventory/purchase/items/get', post },
  get_items_for_purchase_refresh: { link: 'inventory/purchase/items/refresh', post },
  create_purchase: { link: 'inventory/create_purchase_order', post },
  inv_pur_employee_update: { link: '/employee/orders/', version: '2.0.0', put },
  // create_purchase_employee: { link: 'employee/order/create', post,version:'2.0.0' },
  create_purchase_simple: { link: 'inventory/create_simple_purchase_order', post },
  create_purchase_refund: { link: 'inventory/create_refund_purchase_order', post },
  create_purchase_by_receipt: { link: 'inventory/purchase-items-by-receipts', post },
  update_purchase: { link: 'invenory/purchase/edit', post },
  receive_purchase: { link: 'inventory/purchase/receive', post },
  cancel_purchase: { link: 'inventory/purchase/cancel_items' },
  transfer: { link: 'inventory/transfer/get' },
  transfer_by_id: { link: 'inventory/transfer/get' },
  transfers: { link: 'inventory/transfer/get_for_table', post },
  create_transfer: { link: 'inventory/transfer/create', post },
  update_transfer: { link: 'inventory/transfer/update', post },
  receive_transfer: { link: 'inventory/transfer/receive' },
  get_transfer_items: { link: 'inventory/transfer/get_items', post },
  get_transfer_items_refresh: { link: 'inventory/transfer/items/refresh', post },
  stock_adjustments: { link: 'inventory/stock_adjustment/get', post },
  create_stock_adjustment: { link: 'inventory/stock_adjustment/create', post },
  stock_by_id: { link: 'inventory/stock_adjustment/get' },
  inventory_counts: { link: 'inventory/count/get', post },
  inventory_history: { link: 'inventory/history', post },
  inventory_valuation: { link: 'inventory/valuation', post },
  partition_items: { link: 'items/partiations', version: '2.0.0', post },
  partition_valuation: { link: '/inventory/partiation/valuation', version: '2.0.0', post },
  partition_item_id: { link: 'items/partiation', version: '2.0.0', post },
  supplier_valuation: { link: 'inventory/valuation/by_supplier', version: '2.0.0', get },
  create_counts: { link: 'inventory/count/create', post },
  get_inv_count_items: { link: 'inventory/count/items', post },
  update_counts: { link: 'inventory/count/update', post },
  create_counts_history: { link: 'inventory/count/history/create', post },
  counts_history: { link: 'inventory/count/history/get' },
  delete_counts_history: { link: 'inventory/count/history/delete', remove },
  complete_counts: { link: 'inventory/count/complete' },
  counts_by_id: { link: 'inventory/count/get' },
  productions: { link: 'inventory/production/get_table', post },
  create_production: { link: 'inventory/production/create', post },
  production_by_id: { link: 'inventory/production/get' },
  production_items: { link: 'inventory/production/get_items' },
  create_supplier_transaction: { link: 'inventory/supplier/transaction/create', post },
  update_supplier_transaction: { link: 'inventory/supplier/transaction/update', post },
  get_consumptions: { link: 'consumption/get', post },
  create_consumption: { link: 'consumption/create', post },
  get_employees_list: { link: 'user/search', post },
  inv_items_refresh: { link: 'items/list_of_inv/refresh', post },
  inv_pricing: { link: 'items/pricing/one-by-one', post },
  inv_purchase_count: { link: 'inventory/purchase/count/not-pricing' },
  inv_items_fill_sold: { link: 'purchase/items/fill/sold', post },
  supplier_transactions: { link: '/supplier-transactions/get', post },
  supplier_transactions_excel: { link: '/supplier-transactions/get' },
  create_receipt: { link: '/admin-receipt/create', post },
  receipt_set_client: { link: '/admin-receipt/set-client', post },
  inventory_history_report: { link: 'inventory/history/group', post, version: '2.0.0' },
}

export default {
  communications: {
    ...access,
    ...reports,
    ...items,
    ...signing,
    ...settings,
    ...employees,
    ...inventory,
  }
}
